import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ user, allowedRoles, children }) => {
    if (!allowedRoles.includes(user.role)) {
        // If the user's role is not allowed, redirect to the dashboard
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
